import React from "react";
import { Badge, Group } from "@mantine/core";
import type { ClientTag } from "@/types/client";

interface ClientRowTagsProps {
  tags?: ClientTag[];
}

/**
 * Displays client tags as colored badges.
 * Returns null if no tags are present.
 */
const ClientRowTags: React.FC<ClientRowTagsProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Group gap={4} mt={4}>
      {tags.map((tag) => (
        <Badge
          key={tag.id}
          size="xs"
          radius="sm"
          style={{
            backgroundColor: tag.color,
            color: "white",
            textTransform: "none",
          }}
        >
          {tag.name}
        </Badge>
      ))}
    </Group>
  );
};

export default ClientRowTags;
